class LflCardSkuThumbnails extends HTMLElement {
  connectedCallback() {
    this.card = this.closest('.lfl-product-card');
    this.primaryImage = this.card?.querySelector('.lfl-product-card__primary');
    this.mediaLink = this.card?.querySelector('.lfl-product-card__media');
    if (!this.primaryImage || !this.mediaLink) return;

    this.originalSrc = this.primaryImage.currentSrc || this.primaryImage.src;
    this.originalSrcset = this.primaryImage.getAttribute('srcset') || '';
    this.originalHref = this.mediaLink.getAttribute('href') || '';

    this.addEventListener('pointerover', this.handlePreview);
    this.addEventListener('focusin', this.handlePreview);
    this.addEventListener('pointerleave', this.resetPreview);
    this.addEventListener('focusout', this.handleFocusOut);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.handlePreview);
    this.removeEventListener('focusin', this.handlePreview);
    this.removeEventListener('pointerleave', this.resetPreview);
    this.removeEventListener('focusout', this.handleFocusOut);
  }

  handlePreview = (event) => {
    const thumbnail = event.target.closest('[data-lfl-sku-preview]');
    if (!thumbnail || !this.contains(thumbnail)) return;

    const previewImage = thumbnail.dataset.previewImage;
    if (previewImage) {
      this.primaryImage.removeAttribute('srcset');
      this.primaryImage.src = previewImage;
    }

    if (thumbnail.dataset.variantUrl) {
      this.mediaLink.href = thumbnail.dataset.variantUrl;
    }
  };

  resetPreview = () => {
    if (!this.primaryImage) return;
    this.primaryImage.src = this.originalSrc;
    if (this.originalSrcset) this.primaryImage.setAttribute('srcset', this.originalSrcset);
    this.mediaLink.href = this.originalHref;
  };

  handleFocusOut = (event) => {
    if (!this.contains(event.relatedTarget)) this.resetPreview();
  };
}

if (!customElements.get('lfl-card-sku-thumbnails')) {
  customElements.define('lfl-card-sku-thumbnails', LflCardSkuThumbnails);
}
